import React, { useState, useEffect } from 'react';
import { db } from '../../Firebase/Firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useParams, Link } from 'react-router-dom';
import './ServicioDetalle.css';
import Navbar from '../../Components/NavBarAirbnbStyle';
import Footer from '../../Components/footer';
import LoadingScreen from '../../Components/loading';

import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import NavbarMobileVersion from '../../Components/NavBar/NavBarMobileVersion';

const ServicioDetalle = () => {
  const { id } = useParams();
  const [servicio, setServicio] = useState(null);
  const [perfilNegocio, setPerfilNegocio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [paqueteSeleccionado, setPaqueteSeleccionado] = useState(null);
  const abrirModal = (pqt) => {
    setPaqueteSeleccionado(pqt);
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setPaqueteSeleccionado(null);
  };

  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const docRefServicio = doc(db, 'servicios', id);
        const docSnapServicio = await getDoc(docRefServicio);

        if (!docSnapServicio.exists()) {
          setError('Servicio no encontrado');
          setLoading(false);
          return;
        }

        const servicioData = docSnapServicio.data();
        setServicio(servicioData);

        if (servicioData.uid) {
          const docRefUsuario = doc(db, 'usuarios', servicioData.uid);
          const docSnapUsuario = await getDoc(docRefUsuario);

          if (docSnapUsuario.exists()) {
            const dataUsuario = docSnapUsuario.data();
            setPerfilNegocio(dataUsuario.perfilNegocio || null);
            setUserId(docSnapUsuario.id);
          }
        }
      } catch (err) {
        console.error(err);
        setError('Error cargando datos');
      } finally {
        setLoading(false);
      }
    };

    cargarDatos();
  }, [id]);

  const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) return JSON.parse(saved);
    } catch (error) {
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;
    return prefersDark || isNight;
  });

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

  const ubicacion = servicio?.ubicacion;

  const hasUbicacion =
    ubicacion &&
    typeof ubicacion.lat === 'number' &&
    typeof ubicacion.lng === 'number' &&
    !isNaN(ubicacion.lat) &&
    !isNaN(ubicacion.lng);

  const center = hasUbicacion
    ? { lat: ubicacion.lat, lng: ubicacion.lng }
    : null;

  const mapContainerStyle = {
    width: '100%',
    height: '250px',
    borderRadius: '10px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
    marginBottom: '1.5rem'
  };

  const darkMapStyle = [
    {
      "elementType": "geometry",
      "stylers": [{ "color": "#212121" }]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [{ "color": "#757575" }]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [{ "color": "#212121" }]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{ "color": "#383838" }]
    }
  ];

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg' // Reemplaza con tu API Key real

  });

  if (loading) return <LoadingScreen />;
  if (error) return <p style={{ textAlign: 'center', color: 'red' }}>{error}</p>;
  if (!servicio) return null;

  return (
    <>
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div className="servicio-detalle-container">
        <div className="detalle-grid">

          {/* Lado izquierdo */}
          <aside className="lado-izquierdo">
            <div className="imagen-servicio-wrapper">
              {servicio.imagenURL ? (
                <img src={servicio.imagenURL} alt={servicio.nombre} className="imagen-servicio" />
              ) : (
                <div className="imagen-placeholder">No hay imagen</div>
              )}

              {perfilNegocio?.fotoURL && (
                <Link to={`/perfil/${userId}`}>
                  <img
                    src={perfilNegocio.fotoURL}
                    alt={perfilNegocio.nombre || 'Perfil'}
                    className="foto-perfil"
                    title={perfilNegocio.nombre || ''}
                  />
                </Link>
              )}
            </div>

            <h1 className="nombre-servicio">{servicio.nombre}</h1>
            <p className="descripcion-servicio">{servicio.descripcion}</p>
          </aside>

          {/* Lado derecho */}
          <section className="lado-derecho">

            {/* Paquetes */}
            {servicio.paquetes?.length > 0 && (
              <>
                <h3>Paquetes disponibles</h3>
                <div className="paquetes-lista">
                  {servicio.paquetes.map((pqt, i) => (
                    <div key={i} className="paquete-card" onClick={() => abrirModal(pqt)}>
                      <h4>{pqt.nombre}</h4>
                      <p className="precio">
                        ${typeof pqt.precio === 'number' ? pqt.precio.toFixed(2) : parseFloat(pqt.precio).toFixed(2)}
                      </p>
                      <p>
                        {pqt.descripcion.split('\n').slice(0, 3).map((line, index) => (
                          <React.Fragment key={index}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))}
                        {pqt.descripcion.split('\n').length > 3 && <em>...ver más</em>}
                      </p>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Modal */}
            {modalAbierto && paqueteSeleccionado && (
              <div className="modal-backdrop" onClick={cerrarModal}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <h3>{paqueteSeleccionado.nombre}</h3>
                  <p className="precio">
                    ${typeof paqueteSeleccionado.precio === 'number'
                      ? paqueteSeleccionado.precio.toFixed(2)
                      : parseFloat(paqueteSeleccionado.precio).toFixed(2)}
                  </p>
                  <p>
                    {paqueteSeleccionado.descripcion.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                  <button onClick={cerrarModal}>Cerrar</button>
                </div>
              </div>
            )}

            {/* Experto */}
            {perfilNegocio && (
              <>
                <div className="experto-info">
                  <div className="foto-experto-wrapper">
                    <Link to={`/perfil/${userId}`} className="experto-link">
                      <img
                        src={perfilNegocio.fotoURL}
                        alt={perfilNegocio.nombre || 'Perfil'}
                        className="foto-experto"
                      />
                      <h4 className="nombre-experto">{perfilNegocio.nombre || 'Perfil'}</h4>
                    </Link>
                  </div>
                  <div className="descripcion-experto-wrapper">
                    <h3>Sobre el experto</h3>
                    <p className="descripcion-experto">{perfilNegocio.descripcion}</p>
                  </div>
                </div>

                <hr className="separador" />

                {perfilNegocio.telefono && (
                  <a
                    href={`https://wa.me/${perfilNegocio.telefono.replace(/\D/g, '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-whatsapp"
                  >
                    Mensajea a {perfilNegocio.nombre || 'el experto'}
                  </a>
                )}
              </>
            )}

            {/* Información adicional */}
            {servicio.modalidad && (
              <>
                <h3>Modalidad</h3>
                <p>{servicio.modalidad}</p>
              </>
            )}

            {servicio.instruccionesReserva && (
              <>
                <h3>Instrucciones para reservar</h3>
                <p>{servicio.instruccionesReserva}</p>
              </>
            )}

            {/* Mapa (solo si hay ubicación válida) */}
            {isLoaded && hasUbicacion && (
              <>
                <h3>Ubicación del servicio</h3>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={15}
                  options={{
                    styles: isDarkMode ? darkMapStyle : undefined
                  }}
                >
                  <Marker
                    position={center}
                    icon={{
                      url: 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png',
                      scaledSize: new window.google.maps.Size(40, 40)
                    }}
                    onClick={() =>
                      window.open(
                        `https://www.google.com/maps/dir/?api=1&destination=${ubicacion.lat},${ubicacion.lng}`,
                        '_blank'
                      )
                    }
                    title="Ver en Google Maps"
                  />
                </GoogleMap>

                <div style={{ textAlign: 'right', marginTop: '0.5rem' }}>
                  <a
                    href={`https://www.google.com/maps/dir/?api=1&destination=${ubicacion.lat},${ubicacion.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-maps"
                  >
                    <img
                      src="https://c0.klipartz.com/pngpicture/906/84/gratis-png-logotipo-de-la-aplicacion-google-map-diseno-web-adaptable-medios-sociales-iconos-de-computadora-de-google-maps-icono-de-mapa.png"
                      alt="Google Maps"
                      className="maps-icon"
                    />
                    Cómo llegar con Google Maps
                  </a>

                </div>
              </>
            )}



            {/* Portafolio */}
            {Array.isArray(servicio.portafolio) && servicio.portafolio.length > 0 && (
              <>
                <h3>Portafolio</h3>
                <div className="portafolio-grid">
                  {servicio.portafolio.map((item, index) =>
                    item.tipo === 'pdf' ? (
                      <iframe
                        key={index}
                        src={item.url}
                        className="portafolio-pdf"
                        title={`PDF ${index}`}
                      ></iframe>
                    ) : (
                      <img
                        key={index}
                        src={item.url}
                        alt={`Portafolio ${index}`}
                        className="portafolio-img"
                      />
                    )
                  )}
                </div>
              </>
            )}



            {/* FAQ */}
            {servicio.faq?.length > 0 && (
              <>
                <h3>Preguntas Frecuentes (FAQ)</h3>
                <ul className="faq-lista">
                  {servicio.faq.map((item, i) => (
                    <li key={i}>
                      <strong>{item.pregunta}</strong>
                      <p>{item.respuesta}</p>
                    </li>
                  ))}
                </ul>
              </>
            )}

            {/* Testimonios */}
            {servicio.testimonios?.length > 0 && (
              <>
                <h3>Testimonios</h3>
                <div className="testimonios-lista">
                  {servicio.testimonios.map((t, i) => (
                    <div key={i} className="testimonio-card">
                      <p>"{t.comentario}"</p>
                      <p><strong>- {t.nombreCliente}</strong></p>
                      {t.calificacion && <p>Calificación: {t.calificacion} ⭐</p>}
                    </div>
                  ))}
                </div>
              </>
            )}
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ServicioDetalle;
